import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('connected_workflows'),
    description: defineMessage('connecting_approvalmax__ro_or_quickbooks_online'),
    readOnly: defineMessage('this_organisation_is_re_igned_to_a_subscription'),
    manageSubscriptions: defineMessage('manage_subscriptions'),
};
